import React from 'react';
import { Card, CardContent } from '@/components/ui';

export function SystemActivity() {
  return (
    <Card className="border-none shadow-sm h-full flex flex-col">
      <CardContent className="p-6 flex-1 flex flex-col">
        <h3 className="text-sm font-bold text-slate-800 mb-6">Hoạt động hệ thống <span className="text-[10px] font-medium text-slate-400 ml-1">(7 ngày qua)</span></h3>
        
        <div className="flex-1 relative min-h-[180px]">
          {/* Simple Chart Mockup using SVG */}
          <svg className="w-full h-full" viewBox="0 0 400 150">
            {/* Grid lines */}
            {[0, 1, 2, 3].map(i => (
              <line key={i} x1="0" y1={i * 50} x2="400" y2={i * 50} stroke="#f1f5f9" strokeWidth="1" />
            ))}
            
            {/* Chart Line */}
            <path 
              d="M0,100 L50,80 L100,110 L150,100 L200,90 L250,50 L300,100 L350,80 L400,60" 
              fill="none" 
              stroke="#3b82f6" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
            />
            
            {/* Data points */}
            {[
              {x: 50, y: 80, val: 600}, 
              {x: 100, y: 110, val: 500}, 
              {x: 150, y: 100, val: 550}, 
              {x: 200, y: 90, val: 650}, 
              {x: 250, y: 50, val: 800, active: true}, 
              {x: 300, y: 100, val: 600}, 
              {x: 350, y: 80, val: 700}
            ].map((p, i) => (
              <g key={i}>
                <circle cx={p.x} cy={p.y} r={p.active ? "4" : "3"} fill={p.active ? "#3b82f6" : "#fff"} stroke="#3b82f6" strokeWidth="2" />
                {p.active && (
                  <g>
                    <rect x={p.x - 30} y={p.y - 35} width="60" height="25" rx="4" fill="white" className="shadow-sm" filter="drop-shadow(0 1px 2px rgb(0 0 0 / 0.1))" />
                    <text x={p.x} y={p.y - 18} textAnchor="middle" className="text-[10px] font-black fill-slate-800">852 h.động</text>
                  </g>
                )}
              </g>
            ))}
          </svg>

          {/* X-Axis labels */}
          <div className="flex justify-between mt-2 px-2 text-[9px] font-bold text-slate-400">
            <span>09/05</span>
            <span>10/05</span>
            <span>11/05</span>
            <span>12/05</span>
            <span>13/05</span>
            <span>14/05</span>
            <span>15/05</span>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-slate-50">
          <button className="text-[10px] font-bold text-blue-500 flex items-center gap-1 hover:underline">
            Xem chi tiết hoạt động <i className="ri-arrow-right-line" />
          </button>
        </div>
      </CardContent>
    </Card>
  );
}
